import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-184e295c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_component = _resolveComponent("icon-component")

  return (_openBlock(), _createBlock("button", {
    class: ["flex items-center p-4 py-2 text-sm rounded focus:outline-none whitespace-nowrap", _ctx.classes]
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createBlock(_component_icon_component, {
          key: 0,
          icon: _ctx.icon,
          class: "mr-2"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
})